import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import { getWeeklyBarChartOption } from "../chartConfigs";
import { formatTableCellValue } from "../utils";
const OverviewWeeklyChart = ({ data }) => {
  const option = useMemo(() => getWeeklyBarChartOption(data), [data]);
  return (
    <ReactECharts option={option} style={{ height: 300 }} notMerge lazyUpdate />
  );
};

export default OverviewWeeklyChart;
